import type { OnDestroy, OnInit } from '@angular/core';
import { Component, HostBinding, Renderer2, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { PageDataResponse } from '@core-mkt/resolvers/page-data/page-data-response';
import { LazyImgDirective } from '@core-mkt/services/lazy-load/lazy-load.directive';
import { MarketingSyncUserService } from '@core-mkt/services/sync-user/marketing-sync-user.service';
import { cloneDeep } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import type { HeaderNavLink } from './header';
import { headerData, loggedInMyAccountData, myAccountData } from './header-data';
import { HeaderNavLinkComponent } from '../header-nav-link/header-nav-link.component';
import { CollapseLinkComponent } from '../collapse-link/collapse-link.component';
import { SkipNavComponent } from '@core-mkt/shared/components/skip-nav/skip-nav/skip-nav.component';
import { QueryParamDirective } from '@core-mkt/services/query-param/query-param.directive';

@Component({
  selector: 'ace-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [HeaderNavLinkComponent, CollapseLinkComponent, SkipNavComponent, LazyImgDirective, QueryParamDirective],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @HostBinding('class.sticky-header') headerSticky = false;
  private _activateMobileMenu = false;
  private destroy$ = new Subject<void>();
  private route = inject(ActivatedRoute);
  private renderer = inject(Renderer2);
  private syncUserService = inject(MarketingSyncUserService);
  headerData: HeaderNavLink[] = headerData;
  myAccountData: HeaderNavLink[] = myAccountData;
  resolverData: PageDataResponse = cloneDeep(this.route.snapshot?.data['pageData'] as PageDataResponse);
  showDefaultNav = true;
  isLoggedIn = false;
  userInitial = '';
  showInitialDropdown = false;

  ngOnInit(): void {
    if (this.resolverData?.craftData?.headerData) {
      this.headerSticky = this.resolverData.craftData.headerData.isNavSticky;
    }
    if (this.resolverData?.craftData?.headerData?.hideNav) {
      this.showDefaultNav = false;
    }

    this.syncUserService.syncUserReady$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
      if (response?.success && response.data?.isAuthenticated) {
        this.isLoggedIn = true;
        this.userInitial = response.data.initials?.charAt(0) || '';
        this.myAccountData = loggedInMyAccountData;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get headerLogo(): string {
    return 'https://xgrit-ecom.imgix.net/v3_images/transforms/_350x89_crop_center-center_none/ace_ins_logo.svg?v=1730836120&auto=compress,format';
  }

  get activateMobileMenu(): boolean {
    return this._activateMobileMenu;
  }

  set activateMobileMenu(value: boolean) {
    this._activateMobileMenu = value;
    this.setBodyScroll(!value);
  }

  private setBodyScroll(enable: boolean): void {
    if (enable) {
      this.renderer.removeClass(document.body, 'overflow-hidden');
    } else {
      this.renderer.addClass(document.body, 'overflow-hidden');
    }
  }

  toggleMobileMenu(): void {
    this.activateMobileMenu = !this.activateMobileMenu;
  }
}
